import { MenuItem, Drawer, AppBar, List, ListItemButton } from 'components/ui';
import styled from 'styled-components';
import theme from 'theme';

export const SideMenuDrawer = styled(Drawer)`
  &.full-width {
    > div {
      width: 100vw;
    }
  }
  > div {
    z-index: 1;
    position: fixed;
    top: 0;
    padding-top: calc(${theme.height.topMenu} - 10px);
    width: ${theme.width.sideMenu};
    border: none;

    ul {
      padding-top: 0;

      a:first-child {
        margin-top: 0;
      }
    }
  }
`;

export const MenuList = styled(List)``;

export const ListMenuItem = styled(ListItemButton)`
  text-decoration: none;
  color: ${theme.palette.text.primary};
  font-size: ${theme.typography.fontSize}px;
  margin-top: 10px;

  &.Mui-selected {
    background: none;
    color: ${theme.palette.link.menu};
    background-color: ${theme.palette.background.default};

    & .MuiListItemText-primary {
      font-weight: 700 !important;
    }

    & .MuiTypography-root {
      font-weight: 700 !important;
    }

    &:hover {
      background-color: ${theme.palette.background.default};
    }
  }
`;

export const StyledAppBar = styled(AppBar)`
  background-color: ${theme.palette.primary.white};
  box-shadow: none;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: ${theme.height.topMenu};
`;

export const TopMenuItem = styled(MenuItem)`
  text-decoration: none;
  color: ${theme.palette.primary.main};
`;
